import React from "react";
import { GOLFERS } from "../shared/assets/golfer_data";
import { PAYOUTS } from "../shared/assets/payouts";

function comparator(a, b) {
    if (a.position !== b.position) {
        return a.position - b.position;
    }
    let roundsPlayed = 3;
    if ((a.posQualifier === "MC" || a.positionQualifier === "DQ") &&
        (b.posQualifier === "MC" || b.positionQualifier === "DQ")) {
            roundsPlayed = 2;
    }
    let atot = 0;
    let btot = 0;
    for (let i = 0; i<roundsPlayed; i++) {
        atot += a.rounds[i];
        btot += b.rounds[i];
    }
    return atot - btot;
}

function Golfers() {
    const golfers = GOLFERS.sort(comparator).map((golfer) => {
        // const score = golfer.rounds[0] + golfer.rounds[1] + golfer.rounds[2] + golfer.rounds[3];
        var position="";
        
        // console.log("pos " + golfer.position + ": " + PAYOUTS[golfer.position-1])
        // position = golfer.position;
        if (golfer.posQualifier === "MC" || golfer.posQualifier === "WD")
            position = golfer.posQualifier;
        else
            position = golfer.posQualifier + golfer.position;

        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
        });
        const isFinal = true
        let dollars = 0
        if (isFinal)
            dollars = formatter.format(golfer.winnings);
        else
            dollars = formatter.format(PAYOUTS[golfer.position-1]);

        return (
            <div className="grid grid-cols-8 m-1 bg-grey-200" key={golfer.name}>
                <span className="col-span-1">{position}</span>
                <span className="col-span-1">{golfer.curScore}</span>
                <span className="place-self-start col-span-2">{golfer.name}</span>
                <span className="col-span-2">
                    {golfer.rounds[0] + '-' + golfer.rounds[1] + '-' + golfer.rounds[2] + '-' + golfer.rounds[3]}</span>
                <span className="col-span-2">{dollars}</span>
            </div>
        );
    });
    return (
        <div className="flex flex-col lg:w-7/12 w-100 items-center xbg-pink-200">
            <div className="bg-gray-300 mt-14 rounded-lg pb-4">
                <p className="text-3xl my-6 bg-masters-green masters-label">Player Leaderboard</p>
                <div className="grid grid-cols-8 m-1 font-bold">
                    <span className="col-span-1">Pos</span>
                    <span className="col-span-1">Score</span>
                    <span className="place-self-start col-span-2">Golfer</span>
                    <span className="col-span-2">Scores</span>
                    <span className="col-span-2">Winnings</span>
                </div>
                {golfers}
            </div>
        </div>
    );
}

export default Golfers;
